import * as React from "react"
import { Box } from "@mui/material"

import {dipRangeDatesWithToday, DynamicCommonFilters} from "@components";
import {WEBBACK_V2_API, COMMON_FILTERS_COMPONENTS, MONITORING_ROUTES, STOCK_ROUTES} from "@constants";


export default function MonitoringResultsFilters() {

    return <Box data-tour="monitoring-results-filters">
        <DynamicCommonFilters
            stayDefaultFilters
            uniqueID={MONITORING_ROUTES.OVERVIEW_ID}
            blockID={MONITORING_ROUTES.ACCESS_KEY}
            downloadCSV={`${WEBBACK_V2_API}/monitoring/results/csv`}
            downloadCSVOptions={[
                { label: 'Retailer by Column', icon: 'table-columns', extraData: { retailersAsColumns: true } },
                { label: 'Retailer by Row', icon: 'table-list', extraData: {} },
            ]}
            components={[
                { name: COMMON_FILTERS_COMPONENTS.FAV_FILTERS, grid: { xs: 3 }, hide: false, dashboardKey: MONITORING_ROUTES.OVERVIEW_ID },
                { name: COMMON_FILTERS_COMPONENTS.DATE_RANGE, grid: { xs: 8 }, hide: false, sx: { display: 'flex', justifyContent: 'flex-end' }, dateRangeProps: { ranges: dipRangeDatesWithToday} },
                { name: COMMON_FILTERS_COMPONENTS.SHOW_MORE_FILTERS, grid: { xs: 1 }, sx: {display: 'flex', justifyContent: 'flex-end' } },
                { name: COMMON_FILTERS_COMPONENTS.PRODUCTS_IN_STOCK, grid: { xs: 2 }, sx: {display: 'flex', justifyContent: 'center'} },
                { name: COMMON_FILTERS_COMPONENTS.METRIC, grid: { xs: 2 } },
                { name: COMMON_FILTERS_COMPONENTS.MARKET, grid: { xs: 2 } },
                { name: COMMON_FILTERS_COMPONENTS.RETAILER, grid: { xs: 6 } },
                { name: COMMON_FILTERS_COMPONENTS.BRAND, grid: { xs: 3 } },
                { name: COMMON_FILTERS_COMPONENTS.SKU_GROUP, grid: { xs: 3 } },
                { name: COMMON_FILTERS_COMPONENTS.SKU, grid: { xs: 6 }, showAdornment: true },
            ]}
        />
    </Box>
}